import api from './api'

export const getTypes = async () => await api.get('/professional_type/') /*eslint-disable-line */
